enum FontSizes {
  Header1 = "24px",
  Header2 = "20px",
  Header3 = "16px",
  Paragraph = "16px",
}

export { FontSizes };
